export const fetchLoginUrl = `/users/login`;
export const fetchAuthAreasUrl = `/users/list/filters`;
export const fetchAuthUpdateProfileUrl = `/users`;
export const fetchAuthUpdatePasswordUrl = `/users`;
